// {
//           ownerName,
//           createTimeName,
//           warehouseName,
//           code,
//           customerName,
//           skuList,
//           orderRemark,
//           auditStaffName,
//           createName,
//           financeName: '蔡冰',
//           warehouseSatff: ''
// }
export const getSaleTemplate = function(data) {
  const tr = data.skuList.map((i, idx) => {
    return `
        <tr>
            <td>${idx + 1}</td>
            <td>${i.skuCode}</td>
            <td>${i.skuName}</td>
            <td>${i.skuSpec}</td>
            <td>${i.num}</td>
            <td>${i.measureUnit}</td>
        </tr>`
  }).join('')
  return `<!DOCTYPE html>
  <html lang="en">
      <head>
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>销售出库单</title>
          <style>
              * {
                  padding: 0;
                  margin: 0;
                  box-sizing: border-box;
              }
              .report-wrap {
                  width: 1200px;
                  padding: 0 100px;
              }
              .report-title {
                  text-align: center;
                  font-size: 24px;
                  padding: 60px 0 16px;
                  line-height: 1.5;
                  position: relative;
              }
              .bg {
				width: 90px;
				height: 80px;
				position: absolute;
				left: 100px;
				top: 60px;
			  }
              .form-item {
                  margin-bottom: 6px;
                  font-size: 17px;
                  display: flex;
                  align-self: center;
                  line-height: 24px;
              }
              .w-60 {
                  width: 60px;
                  flex: 0 0 60px;
              }
              .form-item__label {
                  color: #292929;
              }
              .form-item__content {
                  color: #666;
                  flex: 1;
              }
              .row {
                  display: flex;
                  align-items: center;
              }
              .col-10 {
                  width: 41.66667%;
                  flex: 0 0 41.66667%;
              }
              .col-14 {
                  width: 58.33333%;
                  flex: 0 0 58.33333%;
              }
              .col-24 {
                  width: 100%;
                  flex: 0 0 100%;
              }
              .col-4 {
                  width: 16.66667%;
                  flex: 0 0 16.66667%;
              }
              .col-5 {
                  width: 20.83333%;
                  flex: 0 0 20.83333%;
              }
              .table {
                  border-collapse: collapse;
                  width: 100%;
                  font-size: 16px;
                  line-height: 20px;
                  margin-bottom: 8px;
              }
              td,
              th {
                  text-align: center;
                  line-height: 28px;
              }
          </style>
      </head>
      <body>
          <section id="app" class="report-wrap">
              <h3 class="report-title">
                  <img class="bg" src="data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCACeAIYDASIAAhEBAxEB/8QAGQABAQEBAQEAAAAAAAAAAAAAAAIBAwQG/8QALhAAAgIAAwYGAQUBAQAAAAAAAAECERIhMQMTQVFhkSIyM3GBobFCUmJy0SPB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/xAAVEQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEQMRAD8A+zAAAAADL6BmgZfQX0NAGX0F9DQBl9BfQ0AYmm2uKNIXqy9kWAAAAAAATJ4VaVmbyK8zp9MwLBG9hz+hvYc/oCmac3tYc/o3ew5/QFPJMhSk9FF/NB7WDWv0Iz2cdHr0CjU28WFXlWZrlNK3GKXuY5XK1dKhLaQaabfZgXF2s+bNOa2kEvN9G72HP6CC9WXsizkpwU3LFquRW9hz+gLBG9hz+hvYPRgWCIycnVL4dgCwAAAAGM0xmgCJ1hrS8izn6kny0+AJrFr+qn+SoPNp6vP54my8/b/0yaaeJBXQGJ2rRoRKf/SS4JIoherL2RYAAAAAAAAAAAYzTGaBMo4lTbS6Gxaa8NUaclFOEG3LRLJgU8ONJ6st9TjcE6UlWWrzFRycXLVavqFdIJZuLyZROz8r/s/yUEQvVl7IsherL2RYAAAAAAAAAAAYzTGaAOa9PZ/B0OfmjVaVldAbvIL9ce5Mnbtfx/JttZYVYpq24rhxsKrZ+V/2f5KMjplzf5NCIXqy9kWQvVl7IsAAAAAAAAAAAMZpjNAmbqLJUoU1KSV9TZ3JqKy4tlKKXBAcvBTp+HK3dmrd4XGM1n/KzphXJClyQVOzdp9yyKcZ2vKywiF6svZFkL1ZeyLAAAAAAAAAAADGaY0mqZO7j17sCwRu49e7G7j17sCwRu49e7G7j17sCwRu49e7G7j17sAvVl7IsmMVHT8lAAAAAAGN0rZx3jcc27zX+Hc88fIlaT8WvuFjtB2uPyc1jaj4tTopXG4tHKlhk+CWT6gdYvw23o2c47R3dPxaZnSqi1J2jnLFJ4o6R06gdFJ4XKSo445LNt5PM6upwf4PPKLezutFl1IR6Iybi3JYV1N3kP3LuZBOnGWefE3dw/bHsVDGmm1nXI5KU1DP74nSUPA4xSV6nDA3ssTev+hXfOEW28XHQmLlg10+zXHDCSb8PAhKo+JNPgB0jiwZvxESlJNru7LwpJ1avU5qLaS43p8Ado3WbsE7Oqy+QEWZS5GgDKsUqqsjQAavUAADKXI0AAAAMpVVKjQAMavU0ADKV3WZoAAAAAAAAAAAAAAAAAAAAAAAAAAAD//Z" >
                  <p>${data.ownerName}</p>
                  <p>销售出库单</p>
              </h3>
              <section>
                <div class="row">
					<div class="col-8">
						<div class="form-item">
							<label class="form-item__label w-90">业务单号：</label>
							<div class="form-item__content">${data.bizOrderCode}</div>
						</div>
					</div>
				</div>
                  <div class="row">
                      <div class="col-10">
                          <div class="form-item">
                              <label class="form-item__label w-60">日期：</label>
                              <div class="form-item__content">${data.createTimeName}</div>
                          </div>
                      </div>
                      <div class="col-14">
                          <div class="form-item">
                              <label class="form-item__label w-60">仓库：</label>
                              <div class="form-item__content">${data.warehouseName}</div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-10">
                          <div class="form-item">
                              <label class="form-item__label w-60">单号：</label>
                              <div class="form-item__content">${data.code}</div>
                          </div>
                      </div>
                      <div class="col-14">
                          <div class="form-item">
                              <label class="form-item__label w-60">客户：</label>
                              <div class="form-item__content">${data.customerName}</div>
                          </div>
                      </div>
                  </div>
              </section>
              <section>
                  <div class="row">
                      <div class="col-24">
                          <table class="table" border="1">
                              <colgroup>
                                  <col width="70" />
                                  <col width="100" />
                                  <col width="325" />
                                  <col width="324" />
                                  <col width="100" />
                                  <col width="80" />
                              </colgroup>
                              <thead>
                                  <tr>
                                      <th>序号</th>
                                      <th>款号</th>
                                      <th>商品名称</th>
                                      <th>商品规格</th>
                                      <th>数量</th>
                                      <th>单位</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  ${tr}
                              </tbody>
                              <tfoot>
                                  <tr>
                                      <td>合计</td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td>${data.total}</td>
                                      <td></td>
                                  </tr>
                              </tfoot>
                          </table>
                      </div>
                  </div>
              </section>
              <section>
                  <div class="row">
                      <div class="col-24">
                          <div class="form-item">
                              <label class="form-item__label w-60">备注：</label>
                              <div class="form-item__content">${data.orderRemark}</div>
                          </div>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-5">
                          <div class="form-item">
                              <label class="form-item__label w-60">制单：</label>
                              <div class="form-item__content">${data.createName}</div>
                          </div>
                      </div>
                      <div class="col-5">
                          <div class="form-item">
                              <label class="form-item__label w-60">财务：</label>
                              <div class="form-item__content">${data.financeName}</div>
                          </div>
                      </div>
                      <div class="col-5">
                          <div class="form-item">
                              <label class="form-item__label w-60">审批：</label>
                              <div class="form-item__content">${data.auditStaffName}</div>
                          </div>
                      </div>
                      <div class="col-5">
                          <div class="form-item">
                              <label class="form-item__label w-60">仓管：</label>
                              <div class="form-item__content">${data.warehouseSatff}</div>
                          </div>
                      </div>
                      <div class="col-4">
                          <div class="form-item">
                              <label class="form-item__label w-60">收货：</label>
                              <div class="form-item__content"></div>
                          </div>
                      </div>
                  </div>
              </section>
          </section>
      </body>
  </html>
  `
}
